window.setMe = (meData) => {
    window.Me = meData;

    if (null !== meData) {
        window.dispatchEvent(new Event('meUpdated'));
    }
}

setMe(null);
